module.exports = __webpack_public_path__ + "img/图层 2.0989a38a.png";